import { render, staticRenderFns } from "./supplier-grid-card.app.vue?vue&type=template&id=4c9eee34&"
import script from "./supplier-grid-card.app.vue?vue&type=script&lang=js&"
export * from "./supplier-grid-card.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports